import * as Yup from "yup";
import { EstimateContents, QuoteContents } from "./BuildQuote/constant";
import tickIcon from "../../../assets/images/current-active-step.svg";
import UncheckIcon from "../../../assets/images/uncheck-icon.svg";
import { AddTruckType } from "../../../enums/AddTruckType";
import { BidToolSettingsConfig } from "../../../types/getSettingsBidConfigDataObject";
import { regexPatterns } from "../../../utils/regexUtil";
import { MaterialTruck } from "../../../context/materialListingContext";
import { TruckDetailLisitng } from "../../../models/TruckDetailListing";
import { dropOffType } from "../../../Types/materialTypes";
import { DocTypes } from "../../../enums/DocTypes";

export const getDefaultValues = (
  fromCxDatabase: boolean,
  customerId?: string,
  data?: BidToolSettingsConfig,
  editRowData?: MaterialTruck,
  editTruckRowData?: TruckDetailListing,
  dropOff?: string,
  dropOffLatLng?: dropOffType,
) => {
  const truckFields = data?.data?.[0]?.baseTruckAssumption?.reduce(
    (acc, { truckType, rate, biddingTons }) => {
      acc[`${truckType}_rate`] = rate;
      acc[`${truckType}_biddingTons`] = biddingTons;
      return acc;
    },
    {},
  );
  return {
    jobName: "",
    customerAccount: fromCxDatabase ? customerId : undefined,
    contactName: undefined,
    deliveryAddress: undefined,
    deliveryAddressCoordinates: "",
    salesPerson: undefined,
    projectInformationSheet: "notReceived",
    taxExemptStatus: "notExempt",
    notes: "",
    materialCategories: undefined,
    materialType: undefined,
    materialName: undefined,
    testingStatus: undefined,
    washedStatus: undefined,
    supply: undefined,
    quarryName: undefined,
    searchRadius: "",
    materialDiameter: "",
    pickupMaterialAddress: undefined,
    pickupMaterialAddressCoordinates: "",
    deliveryMaterialAddress: undefined,
    deliveryMaterialAddressCoordinates: "",
    truckType: String(data?.data?.[0]?.baseTruckAssumption?.[0]?.truckType),
    texasDieselAvg: String(
      data?.data?.[0]?.bidCalculationInputs?.[0]?.texasDieselAvg,
    ),
    truckMPGAvg: data?.data?.[0]?.bidCalculationInputs?.[0]?.truckMPGAvg,
    truckRate: "$105",
    oneWayTime: undefined,
    oneWayMiles: undefined,
    loadingTime: String(data?.data?.[0]?.runInformation?.[0]?.loading),
    unloadingTime: String(data?.data?.[0]?.runInformation?.[1]?.unloading),
    deadheadForwardTime: String(
      data?.data?.[0]?.runInformation?.[2]?.deadheadForwardTime,
    ),
    deadheadForwardMiles: String(
      data?.data?.[0]?.runInformation?.[3]?.deadheadForwardMile,
    ),
    deadheadBackwardTime: String(
      data?.data?.[0]?.runInformation?.[4]?.deadheadBackwardTime,
    ),
    deadheadBackwardMiles: String(
      data?.data?.[0]?.runInformation?.[5]?.deadheadBackwardMile,
    ),
    timeBuffer: String(data?.data?.[0]?.runInformation?.[6]?.timeBufferSemi),
    loadsPerDayTruck: undefined,
    initialPercentage: 12,
    pickupLocation: "",
    pickupLocationCoordinates: "",
    deliveryLocation: String(dropOff),
    deliveryLocationCoordinates: `${dropOffLatLng?.lat}, ${dropOffLatLng?.lng}`,
    truckType: [],
    quantity: undefined,
    truckingPrice: undefined,
    truckCost: undefined,
    materialTruckName: undefined,
    useMaterialMarkup: undefined,
    materialMarkup: undefined,
    materialCost: undefined,
    materialPrice: undefined,
    actualBid: "",
    averageNumberLoads: "",
    maxNumberLoads: "",
    jobNumber: undefined,
    leadId: "",
    dropdown1: undefined,
    dropdown2: undefined,
    dropdown3: undefined,
    onSiteContactName: undefined,
    onSiteContactPhone: undefined,
    onSiteContactEmail: undefined,
    jobSiteAddress: undefined,
    jobSiteAddressCoordinates: "",
    projectBondStatus: "notBonded",
    poInfo1: undefined,
    poInfo2: undefined,
    poInfo3: undefined,
    poInfo4: undefined,
    cashOrCreditSale: false,
    ...truckFields,
  };
};
export const getEditDefaultValues = (
  editDefaultData?: any,
  data?: BidToolSettingsConfig,
) => {
  const truckFields = data?.data?.[0]?.baseTruckAssumption?.reduce(
    (acc, { truckType, rate, biddingTons }) => {
      acc[`${truckType}_rate`] = rate;
      acc[`${truckType}_biddingTons`] = biddingTons;
      return acc;
    },
    {},
  );

  return {
    jobName: editDefaultData?.jobName,
    customerAccount: editDefaultData?.companyId,
    contactName: editDefaultData?.multipleContacts?.[0]?.id,
    deliveryAddress: editDefaultData?.dropoff,
    deliveryAddressCoordinates:
      !!editDefaultData?.dropOffLatLng?.lat &&
      !!editDefaultData?.dropOffLatLng?.lng
        ? editDefaultData?.dropOffLatLng?.lat +
          ", " +
          editDefaultData?.dropOffLatLng?.lng
        : "",
    salesPerson: editDefaultData?.salesPersonId,
    projectInformationSheet: editDefaultData?.projectInformationSheet,
    taxExemptStatus: editDefaultData?.taxExempt,
    notes: editDefaultData?.notes,
    materialCategories: undefined,
    materialType: undefined,
    materialName: undefined,
    testingStatus: undefined,
    washedStatus: undefined,
    supply: undefined,
    quarryName: undefined,
    searchRadius: "",
    materialDiameter: "",
    pickupMaterialAddress: undefined,
    pickupMaterialAddressCoordinates: "",
    deliveryMaterialAddress: undefined,
    deliveryMaterialAddressCoordinates: "",
    truckType: String(data?.data?.[0]?.bidCalculationInputs?.[0]?.truckType),
    texasDieselAvg: String(
      data?.data?.[0]?.bidCalculationInputs?.[0]?.texasDieselAvg,
    ),
    truckRate: "$105",
    oneWayTime: undefined,
    oneWayMiles: undefined,
    loadingTime: String(data?.data?.[0]?.runInformation?.[0]?.loading),
    unloadingTime: String(data?.data?.[0]?.runInformation?.[1]?.unloading),
    deadheadForwardTime: String(
      data?.data?.[0]?.runInformation?.[2]?.deadheadForwardTime,
    ),
    deadheadForwardMiles: String(
      data?.data?.[0]?.runInformation?.[3]?.deadheadForwardMile,
    ),
    deadheadBackwardTime: String(
      data?.data?.[0]?.runInformation?.[4]?.deadheadBackwardTime,
    ),
    deadheadBackwardMiles: String(
      data?.data?.[0]?.runInformation?.[5]?.deadheadBackwardMile,
    ),
    timeBuffer: String(data?.data?.[0]?.runInformation?.[6]?.timeBufferSemi),
    loadsPerDayTruck: undefined,
    initialPercentage: 12,
    pickupLocation: "",
    deliveryLocation: "",
    truckType: [],
    quantity: undefined,
    truckingPrice: undefined,
    truckCost: undefined,
    materialTruckName: undefined,
    useMaterialMarkup: undefined,
    materialMarkup: undefined,
    materialCost: undefined,
    materialPrice: undefined,
    actualBid: "",
    averageNumberLoads: "",
    maxNumberLoads: "",
    jobNumber: undefined,
    leadId: "",
    dropdown1: editDefaultData?.approvalInfo?.dropDown1,
    dropdown2: editDefaultData?.approvalInfo?.dropDown2,
    dropdown3: editDefaultData?.approvalInfo?.dropDown3,
    onSiteContactName:
      editDefaultData?.approvalInfo?.name ?? editDefaultData?.company,
    onSiteContactPhone: editDefaultData?.approvalInfo?.phone,
    onSiteContactEmail: editDefaultData?.approvalInfo?.email,
    jobSiteAddress: editDefaultData?.jobSite,
    jobSiteAddressCoordinates:
      !!editDefaultData?.jobSiteLatLng?.lng &&
      !!editDefaultData?.jobSiteLatLng?.lat
        ? editDefaultData?.jobSiteLatLng?.lng +
          ", " +
          editDefaultData?.jobSiteLatLng?.lat
        : "",
    projectBondStatus: editDefaultData?.approvalInfo?.projectBondStatus,
    poInfo1: editDefaultData?.approvalInfo?.poInformation?.poInfo1,
    poInfo2: editDefaultData?.approvalInfo?.poInformation?.poInfo2,
    poInfo3: editDefaultData?.approvalInfo?.poInformation?.poInfo3,
    poInfo4: editDefaultData?.approvalInfo?.poInformation?.poInfo4,
    cashOrCreditSale: editDefaultData?.cashOrCreditSale,
    ...truckFields,
  };
};
const cleanNumber = (value: any, originalValue: any) => {
  if (typeof originalValue === "string") {
    const cleaned = originalValue.replace(/,/g, "").trim();
    if (cleaned === "") return undefined;
    const parsed = Number(cleaned);
    return isNaN(parsed) ? undefined : parsed;
  }
  return value;
};
export const createJobLeadValidation = Yup.object({
  jobName: Yup.string().required("This is a required field"),
  customerAccount: Yup.string().required("This is a required field"),
  contactName: Yup.string().required("This is a required field."),
  deliveryAddress: Yup.string().required("This is a required field."),
  salesPerson: Yup.string().required("This is a required field."),
  deliveryAddressCoordinates: Yup.string()
    .required("This is a required field.")
    .matches(
      /^-?\d+(\.\d+)?,\s*-?\d+(\.\d+)?$/,
      "Invalid coordinate format. Example: 31.9686, -99.9018",
    ),
});
export const createJobLeadDraftValidation = Yup.object({
  jobName: Yup.string().required("This is a required field"),
  deliveryAddressCoordinates: Yup.string()
    .trim()
    .transform((value) => (value === "" ? undefined : value))
    .matches(
      /^-?\d+(\.\d+)?,\s*-?\d+(\.\d+)?$/,
      "Invalid coordinate format. Example: 31.9686, -99.9018",
    )
    .notRequired(),
});
export const truckMaterialDetailsValidation = Yup.object({
  materialCategories: Yup.string().required("required"),
  quarryName: Yup.string().optional().nullable(),
  materialDiameter: Yup.string()
    .matches(/^\d*\.?\d*$/, "Must be a valid number")
    .nullable(),
  searchRadius: Yup.string()
    .required("required")
    .matches(/^\d*\.?\d*$/, "Must be a valid number"),
  useMaterialMarkup: Yup.number()
    .nullable()
    .transform(cleanNumber)
    .optional()
    .when("materialCost", {
      is: (materialCost: number | null | undefined) =>
        materialCost !== null && materialCost !== undefined && materialCost > 0,
      then: (schema) =>
        schema.max(99.99, "Target margin cannot be 100 or more"),
      otherwise: (schema) => schema,
    }),
  materialCost: Yup.number()
    .nullable()
    .transform(cleanNumber)
    .typeError("invalid entry")
    .test("is-required", "required", function (value) {
      return value !== undefined && value !== null && value !== "";
    })
    .min(0, "Cost cannot be negative"),
  materialPrice: Yup.number()
    .nullable()
    .transform(cleanNumber)
    .typeError("invalid entry")
    .test("is-required", "required", function (value) {
      return value !== undefined && value !== null && value !== "";
    })
    .min(0, "Price cannot be negative"),
  truckingPrice: Yup.number()
    .nullable()
    .transform(cleanNumber)
    .typeError("invalid entry")
    .test("is-required", "required", function (value) {
      return value !== undefined && value !== null && value !== "";
    })
    .min(0, "Price cannot be negative"),
  quantity: Yup.number()
    .nullable()
    .transform(cleanNumber)
    .typeError("invalid entry")
    .test("is-required", "required", function (value) {
      return value !== undefined && value !== null && value !== "";
    })
    .min(0, "Quantity must be greater than zero"),

  materialQuantity: Yup.number()
    .nullable()
    .transform(cleanNumber)
    .typeError("invalid entry")
    .test("is-required", "required", function (value) {
      return value !== undefined && value !== null && value !== "";
    })
    .min(0, "Quantity must be greater than zero"),
  minimumHours: Yup.number()
    .nullable()
    .transform(cleanNumber)
    .typeError("Invalid entry")
    .min(0, "Minimum Hours cannot be negative"),
});

export const truckDetailsAddFromValidation = Yup.object({
  truckingPrice: Yup.number()
    .nullable()
    .transform(cleanNumber)
    .typeError("invalid entry")
    .test("is-required", "required", function (value) {
      return value !== undefined && value !== null && value !== "";
    })
    .min(0, "Price cannot be negative"),
  quantity: Yup.number()
    .nullable()
    .transform(cleanNumber)
    .typeError("invalid entry")
    .test("is-required", "required", function (value) {
      return value !== undefined && value !== null && value !== "";
    })
    .min(0, "Quantity must be greater than zero"),

  pickupLocation: Yup.string().required("required"),
  deliveryLocation: Yup.string().required("required"),
  pickupLocationCoordinates: Yup.string()
    .required("required")
    .matches(
      /^-?\d+(\.\d+)?,\s*-?\d+(\.\d+)?$/,
      "Invalid coordinate format. Example: 31.9686, -99.9018",
    ),
  deliveryLocationCoordinates: Yup.string()
    .required("required")
    .matches(
      /^-?\d+(\.\d+)?,\s*-?\d+(\.\d+)?$/,
      "Invalid coordinate format. Example: 31.9686, -99.9018",
    ),
  materialTruckName: Yup.string().required("required"),
  minimumHours: Yup.number()
    .nullable()
    .transform(cleanNumber)
    .typeError("Invalid entry")
    .min(0, "Minimum Hours cannot be negative"),
});

export const internalApprovalValidation = Yup.object({
  dropdown1: Yup.string().required("This is a required field"),
  dropdown2: Yup.string().required("This is a required field"),
  dropdown3: Yup.string().required("This is a required field"),
  onSiteContactName: Yup.string().required("This is a required field"),
  onSiteContactPhone: Yup.string()
    .transform((value) => {
      if (value === "") return null;
      return value ? value.replace(/[^\d]/g, "") : value;
    })
    .min(10, "Phone number must be 10 digits!")
    .required("This is a required field"),
  onSiteContactEmail: Yup.string()
    .matches(regexPatterns.emailRegex, "Must be a valid email address")
    .required("This is a required field"),
  jobSiteAddress: Yup.string().required("This is a required field"),
});

export const internalApprovalDraftValidation = Yup.object({
  onSiteContactEmail: Yup.string()
    .trim()
    .transform((value) => (value === "" ? undefined : value))
    .matches(regexPatterns.emailRegex, "Must be a valid email address")
    .notRequired(),
  onSiteContactPhone: Yup.string()
    .transform((value) => {
      if (value === "") return null;
      return value ? value.replace(/[^\d]/g, "") : value;
    })
    .notRequired()
    .min(10, "Phone number must be 10 digits!"),
});

export const getValidationSchema = (
  step: number,
  truckFormType: string,
): Yup.ObjectSchema => {
  switch (step) {
    case 1:
      return createJobLeadValidation;
    case 5:
      return internalApprovalValidation;

    default:
      return createJobLeadValidation;
  }
};

export const jobStatus = {
  materialTruckDetails: "Material and Trucking Details",
  buildQuote: "Build Quote",
  quoteShared: "Quote Shared",
  quoteApproved: "Quote Approved",
  l1ApprovalPending: "L1 Approval Pending",
  l1rejected: "L1 Rejected",
  l1Approved: "L1 Approved",
  l2approvalPending: "L2 Approval Pending",
  l2rejected: "L2 Rejected",
  l2Approved: "L2 Approved",
  internalApprovalComplete: "Internal Approval Completed",
  dispatchApproved: "Dispatch Approved",
  jobCreated: "JOB CREATED",
  pendingStatus: "Pending",
  jobLead: "Job Lead",
  internalApprovalDraft: "Internal Approval Draft",
};
export const projectInformationSheetSection = ["Project Information Sheet"];
export const InternalApprovalSubSections = [
  "Project Information Sheet",
  "Project Info Section",
  "Property Legal Description",
  "Property Owner Information",
  "General Contractor Information",
  "Subcontractor Information",
  "Bond Information",
];

export const approvalSubSections = [
  "Project Info Section",
  "Property Legal Description",
  "Property Owner Information",
  "General Contractor Information",
  "Subcontractor Information",
  "Bond Information",
  DocTypes.PROJECT_INFORMATION_SHEET,
  DocTypes.TAX_EXEMPT_CERTIFICATE,
  DocTypes.BOND_INFO_DOCUMENT,
];

export const cashOrCreditAllowedSections = [
  DocTypes.TAX_EXEMPT_CERTIFICATE,
  DocTypes.BOND_INFO_DOCUMENT,
  DocTypes.CASH_CREDIT_SALE_DOCUMENTS,
];

export const JobLeadProgressionMessages = {
  jobUpdatedSuccessfully: "Job Updated Successfully",
  jobCreatedSuccessfully: "Job Created Successfully",
  quoteSubmittedSuccessfully: "Quote Submitted Successfully",
  quoteInfoSubmissionSuccessfully:
    "Information saved, Ready for Internal Approval",
  ordersReadyForDispatch: "Orders are ready for dispatch",
  uploadCustomerApprovalFile:
    "Please upload Customer Approval to proceed to Internal Approval",
  atleastOneFileIsNeeded:
    "Atleast one file should be uploaded from each section",
  projectSheetIsNeeded: "Project Information sheet should be uploaded",
  addTruckDetails: "Please fill truck details or material details to proceed",
  downloadQuoteToProceed: "Please Download or Share the Quote to proceed",
  bondDocumentMissing: "Please upload bond document",
  failedToSubmitQuote: "Failed to submit quote! Please try again.",
  bondInfoDocumentNeeded:
    "Please upload project bond info document to proceed!",
  taxExemptDocumentNeeded: "Please upload tax exempt document to proceed!",
  projectDocumentsNeeded: "Please upload project documents to proceed!",
  jobLeadRestriction:
    "Job lead details cannot be edited for dispatch approved jobs.",
  projectInformationRequired: "Project Information Sheet file is required.",
  taxExemptRequired: "Tax Exempt Certificate file is required.",
  saveDraftSuccess: "Draft saved successfully.",
  failedToSaveDraft: "Failed to save draft",
};

export const hasStatusChanged = (initialResponse, finalResponse) => {
  if (initialResponse?.length !== finalResponse?.length) {
    return true;
  }

  const initialMaterials =
    initialResponse?.filter((item) => item?.type === "material") || [];
  const finalMaterials =
    finalResponse?.filter((item) => item?.type === "material") || [];

  const initialTrucks =
    initialResponse?.filter((item) => item?.type === "truck") || [];
  const finalTrucks =
    finalResponse?.filter((item) => item?.type === "truck") || [];

  if (
    initialMaterials?.length !== finalMaterials?.length ||
    initialTrucks?.length !== finalTrucks?.length
  ) {
    return true;
  }

  const areMaterialsEqual = (mat1, mat2) => {
    const fieldsToCompare = [
      "materialName",
      "materialCost",
      "materialCostType",
      "materialPrice",
      "materialPriceType",
      "truckingCost",
      "truckingCostType",
      "truckingPrice",
      "truckingPriceType",
    ];
    return fieldsToCompare?.every((field) => mat1[field] === mat2[field]);
  };

  const areTrucksEqual = (truck1, truck2) => {
    const fieldsToCompare = [
      "materialName",
      "truckingCost",
      "truckingCostType",
      "truckingPrice",
      "truckingPriceType",
    ];
    return fieldsToCompare?.every((field) => truck1[field] === truck2[field]);
  };

  let finalMaterialsCopy = [...finalMaterials];
  for (const initialMat of initialMaterials) {
    const matchIndex = finalMaterialsCopy?.findIndex((finalMat) =>
      areMaterialsEqual(initialMat, finalMat),
    );

    if (matchIndex === -1) {
      return true;
    }
    finalMaterialsCopy?.splice(matchIndex, 1);
  }

  let finalTrucksCopy = [...finalTrucks];
  for (const initialTruck of initialTrucks) {
    const matchIndex = finalTrucksCopy?.findIndex((finalTruck) =>
      areTrucksEqual(initialTruck, finalTruck),
    );

    if (matchIndex === -1) {
      return true;
    }
    finalTrucksCopy?.splice(matchIndex, 1);
  }
  return false;
};

export const internalApprovalPastStates = [
  jobStatus.internalApprovalDraft,
  jobStatus.internalApprovalComplete,
  jobStatus.l1ApprovalPending,
  jobStatus.l1Approved,
  jobStatus.l2Approved,
  jobStatus.l2approvalPending,
  jobStatus.l1rejected,
  jobStatus.l2rejected,
  jobStatus.dispatchApproved,
];

export const quoteApprovedStates = [
  jobStatus.quoteApproved,
  ...internalApprovalPastStates,
];

export const buildQuotePastStates = [
  jobStatus.quoteShared,
  ...quoteApprovedStates,
];

export const normalizeEmpty = (value) => {
  if (value === null || value === undefined) {
    return "";
  }
  return String(value);
};

export const hasChangesInJobLead = (payload, apiResponse) => {
  if (
    normalizeEmpty(payload?.notes).trim() !==
    normalizeEmpty(apiResponse?.notes).trim()
  )
    return true;
  if (
    normalizeEmpty(payload?.dropOff).trim() !==
    normalizeEmpty(apiResponse?.dropoff).trim()
  )
    return true;
  if (payload?.companyId !== apiResponse?.companyId) return true;
  if (payload?.salesPerson !== apiResponse?.salesPersonId) return true;
  const apiContactId = apiResponse?.multipleContacts?.[0]?.id;
  if (payload?.contactDetails !== apiContactId) return true;
  if (
    normalizeEmpty(payload?.projectInformationSheet).toLowerCase() !==
    normalizeEmpty(apiResponse?.projectInformationSheet).toLowerCase()
  )
    return true;
  if (
    normalizeEmpty(payload?.taxExemptStatus).toLowerCase() !==
    normalizeEmpty(apiResponse?.taxExempt).toLowerCase()
  )
    return true;
  const payloadLatLngStr = normalizeEmpty(payload?.dropOffLatLng).trim();
  if (payloadLatLngStr) {
    const [lat, lng] = payloadLatLngStr.split(",").map(Number);
    const apiLat = apiResponse?.dropOffLatLng?.lat;
    const apiLng = apiResponse?.dropOffLatLng?.lng;
    if (
      apiLat === undefined ||
      apiLng === undefined ||
      lat.toFixed(6) !== apiLat.toFixed(6) ||
      lng.toFixed(6) !== apiLng.toFixed(6)
    ) {
      return true;
    }
  } else if (apiResponse?.dropOffLatLng) {
    return true;
  }
  return false;
};

export const hasApprovalInfoChanged = (payload, initialDetails) => {
  if (!initialDetails) {
    return true;
  }
  const getInitialValue = (path) => {
    return path.split(".").reduce((acc, part) => acc?.[part], initialDetails);
  };

  const normalize = (value) => {
    if (value === null || value === undefined) return "";

    if (typeof value === "string") {
      const trimmed = value.trim();
      if (!!!trimmed) return "";
      const num = Number(trimmed);
      return Number.isNaN(num) ? trimmed : num;
    }

    return value;
  };

  const fieldMap = [
    { payloadKey: "name", initialPath: "approvalInfo.name" },
    { payloadKey: "phone", initialPath: "approvalInfo.phone" },
    { payloadKey: "email", initialPath: "approvalInfo.email" },
    { payloadKey: "dropDown1", initialPath: "approvalInfo.dropDown1" },
    { payloadKey: "dropDown2", initialPath: "approvalInfo.dropDown2" },
    { payloadKey: "dropDown3", initialPath: "approvalInfo.dropDown3" },
    {
      payloadKey: "projectBondStatus",
      initialPath: "approvalInfo.projectBondStatus",
    },
    { payloadKey: "taxExempt", initialPath: "taxExempt" },
    { payloadKey: "jobSite", initialPath: "jobSite" },
    { payloadKey: "jobSiteLat", initialPath: "jobSiteLatLng.lat" },
    { payloadKey: "jobSiteLang", initialPath: "jobSiteLatLng.lng" },
    {
      payloadKey: "projectInformationSheet",
      initialPath: "projectInformationSheet",
    },
    {
      payloadKey: "poInfo1",
      initialPath: "approvalInfo.poInformation.poInfo1",
    },
    {
      payloadKey: "poInfo2",
      initialPath: "approvalInfo.poInformation.poInfo2",
    },
    {
      payloadKey: "poInfo3",
      initialPath: "approvalInfo.poInformation.poInfo3",
    },
    {
      payloadKey: "poInfo4",
      initialPath: "approvalInfo.poInformation.poInfo4",
    },
    { payloadKey: "cashOrCreditSale", initialPath: "cashOrCreditSale" },
  ];

  for (const field of fieldMap) {
    const payloadValue = normalize(payload[field.payloadKey]);
    const initialValue = normalize(getInitialValue(field.initialPath));

    if (payloadValue !== initialValue) {
      return true;
    }
  }
  return false;
};

export const DispatchModalConstants = {
  NaviagateToCustomerProfile: "Go to Customer Profile",
  DispatchApprovedLabel: "Dispatch Approved",
  ApproveJobForDispatchLabel: "Approve Job for Dispatch",
};

export const NavButtonConstants = {
  SAVE: "Save",
  SAVE_DRAFT: "Save Draft",
  SAVE_AND_CONTINUE: "Save and Continue",
  CONTINUE: "Continue",
  PREVIOUS: "Previous",
};

export const getStageId = (
  currentStageId: string,
  currentStep: number,
): string | undefined => {
  const transitions: Record<number, Record<string, string>> = {
    1: { [jobStatus.jobLead]: jobStatus.materialTruckDetails },
    2: { [jobStatus.materialTruckDetails]: jobStatus.buildQuote },
    3: { [jobStatus.buildQuote]: jobStatus.quoteShared },
    4: { [jobStatus.quoteShared]: jobStatus.quoteApproved },
    5: {
      [jobStatus.quoteApproved]: jobStatus.l1ApprovalPending,
      [jobStatus.l1rejected]: jobStatus.l1ApprovalPending,
      [jobStatus.l2rejected]: jobStatus.l1ApprovalPending,
      [jobStatus.internalApprovalDraft]: jobStatus.l1ApprovalPending,
      [jobStatus.internalApprovalComplete]: jobStatus.l1ApprovalPending,
    },
  };

  return transitions[currentStep]?.[currentStageId];
};

export const steps = [
  {
    title: "Job Lead",
    activeIcon: tickIcon,
    inactiveIcon: UncheckIcon,
  },
  {
    title: "Material & Truck Details",
    activeIcon: tickIcon,
    inactiveIcon: UncheckIcon,
  },
  {
    title: "Build Quote",
    activeIcon: tickIcon,
    inactiveIcon: UncheckIcon,
  },
  {
    title: "Customer Approval",
    activeIcon: tickIcon,
    inactiveIcon: UncheckIcon,
  },
  {
    title: "Internal Approval",
    activeIcon: tickIcon,
    inactiveIcon: UncheckIcon,
  },
];

export const createJobCommonConstants = {
  removeFileConfirmationTitle: (docType: DocTypes) =>
    `Are you sure you want to remove this ${docType}?`,
  removeConfirmationContent: "This action cannot be undone.",
};
